import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {o, OdataQuery} from "odata";
import {CollectionPropertyFilter, ColumnConfig, TableConfig} from "../data-table.component";
import {FilterSettings} from "./filter";
import {FilterComponent} from "./filter/filter.component";
import {StringFilterComponent} from "./string-filter/string-filter.component";
import {IsFilterablePipe} from "./filterable.pipe";

export class FilterEntry {
    Column: ColumnConfig;
    FilterSettings: FilterSettings
}

@Component({
    selector: 'data-table-filter',
    templateUrl: './data-table-filter.component.html'
})
export class DataTableFilterComponent implements OnInit {

    @Input('config')
    public Config: TableConfig;

    private _prefilter: string;
    
    @Input('prefilter')
    public set Prefilter(v: string) {
        this._prefilter = v;
        this.updateFilter();
    };
    
    @Input('initialFilters')
    public InitialFilters: FilterEntry[] = [];
    
    public AnyFieldFilterColumn = <ColumnConfig><any>{
        DisplayName: 'Any Field',
        FilterType: StringFilterComponent
    };
    
    @Output('filterChange')
    public FilterChange = new EventEmitter<string>(true);
    
    public FilterEntries: FilterEntry[] = [];
    
    public NewFilterColumn: ColumnConfig;
    public NewFilterSettings: FilterSettings;
    
    constructor() {}
    
    ngOnInit() {
        this.NewFilterColumn = this.Config.Columns.find(c => c.IsDefaultFilter && c.FilterType);
        if (!this.NewFilterColumn) {
            if ((this.Config.AnyFieldFilterPropertyNames && this.Config.AnyFieldFilterPropertyNames.length)) {
                this.NewFilterColumn = this.AnyFieldFilterColumn;
            }
            else {
                this.NewFilterColumn = this.Config.Columns.find(c => c.FilterType);
            }
        }
        
        if (this.InitialFilters.length > 0) {
            this.FilterEntries.push(...this.InitialFilters);
            setTimeout(() => this.updateFilter(), 500);
        }
    }

    public addFilter() {
        this.FilterEntries.push({
            Column: this.NewFilterColumn,
            FilterSettings: this.NewFilterSettings
        });
        this.NewFilterColumn = null;
        this.NewFilterSettings = null;
        
        this.updateFilter();
    }
    
    public removeFilter(i: number) {
        this.FilterEntries.splice(i, 1);

        this.updateFilter();
    }
    
    public updateFilter() {
        let filter = this.BuildFilterString(this.FilterEntries, this._prefilter);
        this.FilterChange.emit(filter);
    }
    
    private BuildFilterString(filters: FilterEntry[], prefilter?: string) {
        
        let filter = "";

        if (prefilter) {
            filter = '(' + prefilter + ')';
        }

        let compiledFilters =
            filters
                .map(f => {
                    let propertyNames: (CollectionPropertyFilter|string)[] = f.Column.DisplayName == 'Any Field'
                        ? this.Config.AnyFieldFilterPropertyNames
                        : [f.Column.FilterProperty || f.Column.PropertyName];
                    
                    return '(' + f.FilterSettings.GetFilter(...propertyNames) + ')';
                })
                .join(' and ');

        if (compiledFilters) {
            if (filter) {
                filter += ' and ';
            }
            filter += compiledFilters;
        }
        
        return filter;
    }
}
